import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable'
import { environment } from 'environments/environment';

@Injectable()
export class PrintInvoiceReportLogService {

    constructor(private http: HttpClient) { }

    add = (data): Observable<any> => {
        return this.http.post<any>(`${environment.order}/PrintInvoiceReportLog`, data);
    }

    getByPatientStatementId = (id: number): Observable<any> => {
        return this.http.get<any>(`${environment.order}/PrintInvoiceReportLog/GetByPatientStatementId?Id=${id}`);
    }
}